import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=a445170e&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"
import style0 from "./advantage.vue?vue&type=style&index=0&id=a445170e&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a445170e",
  null
  
)

export default component.exports